import { type SerializedPageStructure } from '@wix/document-services-types'
import { TEXT_ROLE } from '@wix/wix-data-client-common-standalone'

import {
  modifyConnectionConfigOfComponentAndControllerWithVeloIds,
  setConnectionConfigPropertyField,
} from './utils'
import { ROUTER_DATASET_VELO_ID } from './veloIds'

export const rebindItemDisplayName = ({
  page,
  displayFieldKey,
}: {
  page: SerializedPageStructure
  displayFieldKey: string
}): SerializedPageStructure =>
  modifyConnectionConfigOfComponentAndControllerWithVeloIds({
    page,
    componentVeloId: 'itemDisplayName',
    controllerVeloId: ROUTER_DATASET_VELO_ID,
    role: TEXT_ROLE,
    modifyConnectionConfig: config =>
      setConnectionConfigPropertyField({
        config,
        propertyName: '$text',
        fieldKey: displayFieldKey,
      }),
  })
